var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[_c('v-card',{staticClass:"border-bottom-card overflow-x no-boxshadow"},[_c('highlightjs',{staticClass:"code-scope",attrs:{"language":"html","code":_vm.typescripttemplate}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }